// Small pieces the operations screens share (add-ons, failed events, costs, report delivery).
import { ApiError } from "@companyos/sdk";
import { Badge } from "@companyos/ui";
import type { EntitlementStatus } from "../api/types";

/** The problem's own words, else a fallback (the toast already carries the full problem). */
export function problemText(error: unknown, fallback: string): string {
  if (error instanceof ApiError) return error.problem?.detail ?? error.problem?.title ?? fallback;
  return fallback;
}

const STATUS: Record<
  EntitlementStatus,
  { label: string; variant: "success" | "info" | "warning" | "neutral" }
> = {
  active: { label: "Active", variant: "success" },
  trial: { label: "Trial", variant: "info" },
  grace: { label: "Read-only (grace)", variant: "warning" },
  disabled: { label: "Off", variant: "neutral" },
};

export function EntitlementBadge({ status }: { status: EntitlementStatus }) {
  const s = STATUS[status];
  return (
    <Badge variant={s.variant} dot data-status={status}>
      {s.label}
    </Badge>
  );
}

export const ENTITLEMENT_LABELS: Record<EntitlementStatus, string> = {
  active: STATUS.active.label,
  trial: STATUS.trial.label,
  grace: STATUS.grace.label,
  disabled: STATUS.disabled.label,
};
